<template>
  <div :class="$style[classes]">
    <pt-page-title title="跑批监控"></pt-page-title>
    <pt-page-menu-filter v-if="pageLoading" :tabs="batchTabs" v-model="selectTab" state="type"></pt-page-menu-filter>
    <template v-if="selectTab === 'abnormalList'">
      <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
        <template>
          <el-button type="primary" @click="Filter()">筛选</el-button>
          <el-button type="primary" @click="exporTable" :loading="exportLoading">导出</el-button>
          <el-button type="primary" @click="exportHistoryTable">导出历史</el-button>
          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
        </template>
      </pt-page-factor-filter>
      <pt-batch-monitoring-table ref="table" :tableLabels="tableLabels" :queryParams="queryParams" :isFromRouter="isFromRouter"></pt-batch-monitoring-table>
    </template>
    <table v-loading="loading" v-else>
      <pt-form-list-item label="本轮跑批时间：">
        {{ data.batch_startTime }}
      </pt-form-list-item>
      <pt-form-list-item label="本次跑批时间：">
        {{ data.day_startTime }} - {{ data.day_endTime }}
      </pt-form-list-item>
      <pt-form-list-item label="本轮跑批进度：">
        {{ data.percentage_progress }}
      </pt-form-list-item>
      <pt-form-list-item label="本轮已跑批用户数：">
        {{ data.batchUserCount }}
      </pt-form-list-item>
      <pt-form-list-item label="本次跑批用户数(成功/失败)：">
        <template v-if="data.results && data.results.user">
          <div class="result-message">
            <div class="success">{{ data.results.user.success }}</div>
            /
            <div class="failure">{{ data.results.user.failure }}</div>
            <!-- <el-button v-if="data.results.user.failure" type="text" @click="viewData('user')">查看异常数据</el-button> -->
          </div>
        </template>
      </pt-form-list-item>
      <pt-form-list-item label="本次跑批合同数(成功/失败)：">
        <template v-if="data.results && data.results.contract">
          <div class="result-message">
            <div class="success">{{ data.results.contract.success }}</div>
            /
            <div class="failure">{{ data.results.contract.failure }}</div>
            <!-- <el-button v-if="data.results.contract.failure" type="text" @click="viewData('contract')">查看异常数据</el-button> -->
          </div>
        </template>
      </pt-form-list-item>
      <pt-form-list-item label="本次跑批订单数(成功/失败)：">
        <template v-if="data.results && data.results.order">
          <div class="result-message">
            <div class="success">{{ data.results.order.success }}</div>
            /
            <div class="failure">{{ data.results.order.failure }}</div>
            <!-- <el-button v-if="data.results.order.failure" type="text" @click="viewData('order')">查看异常数据</el-button> -->
          </div>
        </template>
      </pt-form-list-item>
      <pt-form-list-item label="本次跑批基本情况报告数(成功/失败)：">
        <template v-if="data.results && data.results.basic_report">
          <div class="result-message">
            <div class="success">{{ data.results.basic_report.success }}</div>
            /
            <div class="failure">{{ data.results.basic_report.failure }}</div>
            <!-- <el-button v-if="data.results.basic_report.failure" type="text" @click="viewData('basic_report')">查看异常数据</el-button> -->
          </div>
        </template>
      </pt-form-list-item>
      <pt-form-list-item label="本次跑批年度监测报告数(成功/失败)：">
        <template v-if="data.results && data.results.year_report">
          <div class="result-message">
            <div class="success">{{ data.results.year_report.success }}</div>
            /
            <div class="failure">{{ data.results.year_report.failure }}</div>
            <!-- <el-button v-if="data.results.year_report.failure" type="text" @click="viewData('year_report')">查看异常数据</el-button> -->
          </div>
        </template>
      </pt-form-list-item>
      <pt-form-list-item label="本次跑批异常总数：">
        {{ data.dayFailureCount }}
      </pt-form-list-item>
    </table>
  </div>
</template>

<script>
// 组件class前缀
import { batchTabs, tableLabels, tableLabelsOfOrder, tableLabelsOfUser, tableLabelsOfReport, filterLabels } from './bactch-options'
import ptBatchMonitoringTable from './pt-pt-batch-monitoring-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-batch-monitoring'
export default {
  name: 'pt-batch-monitoring',
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    loading: Boolean,
    exportLoading: Boolean
  },
  data () {
    return {
      pageLoading: true,
      batchTabs: batchTabs,
      selectTab: 'statisc',
      filterLabels: filterLabels,
      params: {},
      queryParams: {},
      isFromRouter: false
    }
  },
  components: {
    ptBatchMonitoringTable
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableData () {
      return this.$refs.table.tableData
    },
    tableLabels () {
      let labels = tableLabels
      if (this.queryParams.business && this.queryParams.business.length === 1) {
        switch (this.queryParams.business[0]) {
          case 'order':
            labels = tableLabelsOfOrder
            break
          case 'contract':
            labels = tableLabelsOfOrder
            break
          case 'user':
            labels = tableLabelsOfUser
            break
          case 'basic_report' || 'year_report':
            labels = tableLabelsOfReport
            break
          default:
            labels = tableLabels
            break
        }
      }
      return labels
    }
  },
  watch: {
    selectTab: {
      handler: function (val) {
        if (val !== 'abnormalList') {
          this.$emit('getCurrentBatch')
        }
      },
      immediate: true
    }
  },
  methods: {
    exporTable () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          for (var key in this.params) {
            if (!this.params[key]) {
              this.$delete(this.params, key)
            }
            if (key === 'createdtime') {
              this.$delete(this.params[key], 'index')
              this.params = { ...this.params, ...this.params[key] }
              this.$delete(this.params, key)
            }
            if (key === 'businessType') {
              this.params.business = []
              this.params.business.push(this.params.businessType)
            }
          }
          let paramsData = { ...this.params }
          // this.params.searchKey = this.searchKey ? this.searchKey : null
          this.$emit('getExceptionExport', paramsData)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryTable () {
      this.$router.push('/export-history-batch?name=object_log_export')
    },
    viewData (val) {
      this.selectTab = 'abnormalList'
      this.$router.push(`/batch-monitoring?type=statisc&businessType=${val}`)
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      this.$delete(this.params, 'type')
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'createdtime') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
        if (key === 'businessType') {
          this.params.business = []
          this.params.business.push(this.params.businessType)
        }
      }
      this.queryParams = { ...this.params }
      this.$delete(this.queryParams, 'businessType')
      if (this.queryParams.type) {
        this.$delete(this.queryParams, 'type')
      }
    },
    cleanParams () {
      emptyObject(this.params)
      this.Filter()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-batch-monitoring{
  :global{
    .result-message{
      display: flex;
      align-items: center;
      .el-button{
        margin-left: 20px;
      }
    }
    .success{
    }
    .failure{
      color: #f56c6c
    }
  }
}
</style>
